import { MenuItemType } from './index';

const ADMIN: MenuItemType[] = [
  {
    key: 'main',
    label: 'Gerenciar plataforma',
    isTitle: true,
  },
  {
    key: 'Escritorios',
    label: 'Escritórios',
    icon: 'fa-regular fa-building',
    url: '/manager/escritorios',
  },
  {
    key: 'Usuarios',
    label: 'Usuários',
    icon: 'fa-regular fa-user',
    url: '/manager/usuarios',
  },
  {
    key: 'Administradores',
    label: 'Administradores',
    icon: 'fa-regular fa-circle-user',
    url: '/manager/administradores',
  },
  /*
  {
    key: 'Planos',
    label: 'Planos',
    icon: 'fa-regular fa-clipboard',
    //url:'/manager/planos',
    disable: true,
  },
  {
    key: 'Settings',
    label: 'Configurações',
    icon: 'fa-solid fa-gear',
    //url:'/manager/configuracoes',
    disable: true,
  },
  */
];

export default ADMIN;
